import { ROUTES } from "const";
import { courseService } from "libs/api";

export class MNESC {

    static async getDashboardCards(registrationCode) {

        let cards = this.getFixedCards();
        const result = await courseService.mneActiveLink(registrationCode);

        if (result.data.payload) {
            const { payload } = result.data;
            if (payload.simulationEnable === '1') {
                cards.push({
                    title: 'Simulazione Esami',
                    link: ROUTES.MNE_SIMULATION_EXAM,
                    img: '/img/icon/8.png', className: 'image-box'
                });
            }
        }

        return cards;
    }

    static getFixedCards() {

        return [
            {
                title: 'Materiale didattico', link: ROUTES.LEARNING_MAIN,
                img: '/img/icon/lessons.png', className: 'image-box'
            }, {
                title: 'Istruzioni Operative', link: ROUTES.COURSE_ISTRUCTION,
                img: '/img/icon/graduate.png', className: 'image-box'
            }, {
                title: 'Bando', link: ROUTES.COURSE_MANIFESTO,
                img: '/img/icon/graduate.png', className: 'image-box'
            }, {
                title: 'Assistenza Didattica', link: ROUTES.COURSE_TUTOR_MNE,
                img: '/img/icon/call.png', className: 'image-box'
            }, {
                title: 'Assistenza Amministrativa', link: ROUTES.ASSISTANCE_TELEPHONE_MNE,
                img: '/img/icon/call.png', className: 'image-box'
            }, {
                title: 'Assistenza Tecnica', link: ROUTES.ASSISTANCE_ONLINE_MNE,
                img: '/img/icon/call.png', className: 'image-box'
            }, {
                title: 'Situazione pagamenti', link: ROUTES.COURSE_PAYMENTS,
                img: '/img/icon/payment.png', className: 'image-box'
            }, {
                title: 'Fatture', link: ROUTES.COURSE_INVOICES,
                img: '/img/icon/invoice.png', className: 'image-box'
            }
        ];
    }
}
